/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICompanyTypePickerViewProps } from './nos-companytype-picker';

/**
 * Update Component.
 * @param param0 - Root param.
 * @param param0.availableCountries
 * @returns - Node.
 */
const CompanyTypePickerNode: React.FC<any> = ({ availableCompanyTypes }) => {
    return <Node className=''>{availableCompanyTypes}</Node>;
};

/**
 * View Component.
 * @param props - Props.
 * @returns - CompanyTypes Module.
 */
const NosCompanyTypePickerView: React.FC<ICompanyTypePickerViewProps> = props => {
    const { CompanyTypePicker, availableCompanyTypes } = props;
    return (
        <Module {...CompanyTypePicker}>
            <CompanyTypePickerNode availableCompanyTypes={availableCompanyTypes} />
        </Module>
    );
};

export default NosCompanyTypePickerView;
